import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import { OverlayType } from './overlay.constants';

export const { Types: OverlayTypes, Creators: OverlayActions } = createActions(
  {
    showPolicy: ['isStandalone'],
    showPrivacy: ['isStandalone'],
    showTerms: ['isStandalone'],
    showCookies: ['isStandalone'],
    hideOverlay: [],
  },
  { prefix: 'POLICY_OVERLAY_' }
);

export const INITIAL_STATE = Immutable({
  activeOverlay: null,
  isStandalone: false,
});

const showPrivacy = (state, { isStandalone = false }) =>
  state.set('activeOverlay', OverlayType.PRIVACY).set('isStandalone', isStandalone);

const showPolicy = (state, { isStandalone = false }) =>
  state.set('activeOverlay', OverlayType.POLICY).set('isStandalone', isStandalone);

const showTerms = (state, { isStandalone = false }) =>
  state.set('activeOverlay', OverlayType.TERMS).set('isStandalone', isStandalone);

const showCookies = (state, { isStandalone = false }) =>
  state.set('activeOverlay', OverlayType.COOKIES).set('isStandalone', isStandalone);

const hideOverlay = state => state.set('activeOverlay', null).set('isStandalone', false);

export const reducer = createReducer(INITIAL_STATE, {
  [OverlayTypes.SHOW_POLICY]: showPolicy,
  [OverlayTypes.SHOW_TERMS]: showTerms,
  [OverlayTypes.SHOW_PRIVACY]: showPrivacy,
  [OverlayTypes.SHOW_COOKIES]: showCookies,
  [OverlayTypes.HIDE_OVERLAY]: hideOverlay,
});
